// pages/LoginPage.js
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import '../App.css';

function LoginPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberPwd, setRememberPwd] = useState(false);
  const [captcha, setCaptcha] = useState('');
  const [inputCaptcha, setInputCaptcha] = useState('');
  const [error, setError] = useState({ user: false, user1: false, captcha: false });
  const [errorMsg, setErrorMsg] = useState('');

  const generateCaptcha = () => {
    const chars = '0123456789';
    let result = '';
    for (let i = 0; i < 4; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptcha(result);
  };

  useEffect(() => {
    generateCaptcha();
    const savedUser = localStorage.getItem('rememberUser');
    const savedPwd = localStorage.getItem('rememberPwd');
    if (savedUser && savedPwd) {
      setUsername(savedUser);
      setPassword(savedPwd);
      setRememberPwd(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError({ user: false, user1: false });
    setErrorMsg('');

    const inputUsername = username.trim();
    const inputPassword = password.trim();

    if (!inputUsername || !inputPassword) {
      setError({ user: false, user1: true });
      return;
    }

    if (inputCaptcha !== captcha) {
      setError({ user: true, user1: false, captcha: true });
      generateCaptcha();
      return;
    }

    try {
      const result = await api.login({ username: inputUsername, password: inputPassword });

      if (result.success) {
        localStorage.setItem('currentUser', JSON.stringify(result.user));
        localStorage.setItem('sessionToken', result.token);
        if (result.clientIp) {
          localStorage.setItem('loginIp', result.clientIp);
        }
        if (rememberPwd) {
          localStorage.setItem('rememberUser', inputUsername);
          localStorage.setItem('rememberPwd', inputPassword);
        } else {
          localStorage.removeItem('rememberUser');
          localStorage.removeItem('rememberPwd');
        }

        navigate('/app/admin');
      } else {
        // 其他登录失败（密码错误 / 账号已被其他设备登录）
        setErrorMsg(result.message || 'Incorrect username or password');
        setError({ user: true, user1: false, captcha: false });
        generateCaptcha();
      }
    } catch (err) {
      setErrorMsg('Request error, please try again');
      setError({ user: true, user1: false, captcha: false });
      generateCaptcha();
    }
  };

  const handleInputChange = () => {
    setError({ user: false, user1: false, captcha: false });
    setErrorMsg('');
  };

  return (
    <>
      <div className="grid-overlay"></div>
      <div className="login-card">
        <div style={{ textAlign: 'center', marginBottom: 8 }}>
          <img
            src="logo.png"
            alt="VPP EMS"
            style={{
              height: 56,
              width: 'auto',
              marginBottom: 8,
              background: 'rgba(243, 246, 248, 0.5)',
              borderRadius: 10,
              padding: '8px 16px',
              border: '1px solid rgba(98, 123, 185, 0.3)',
            }}
          />
        </div>
        <div className="system-title">{t('login.systemTitle')}</div>

        <form onSubmit={handleSubmit} id="loginForm">
          <div className="input-group">
            <label>{t('login.account')}</label>
            <input type="text" placeholder={t('login.accountPlaceholder')} value={username} onChange={(e) => setUsername(e.target.value)} onInput={handleInputChange} />
            <div className="error-tip" style={{ display: error.user ? 'block' : 'none' }}>
              {errorMsg || t('login.errorWrong')}
            </div>
            <div className="error-tip" style={{ display: error.user1 ? 'block' : 'none' }}>{t('login.errorEmpty')}</div>
          </div>

          <div className="input-group">
            <label>{t('login.password')}</label>
            <input type="password" placeholder={t('login.passwordPlaceholder')} value={password} onChange={(e) => setPassword(e.target.value)} onInput={handleInputChange} />
          </div>

          <div className="input-group captcha-group">
            <label>{t('login.captcha')}</label>
            <div className="captcha-input">
              <input
                type="text"
                placeholder={t('login.captchaPlaceholder')}
                value={inputCaptcha}
                onChange={(e) => setInputCaptcha(e.target.value)}
                onInput={handleInputChange}
                maxLength={4}
              />
              <div className="captcha-code" onClick={generateCaptcha} title={t('common.refresh')}>
                {captcha}
              </div>
            </div>
            <div className="error-tip" style={{ display: error.captcha ? 'block' : 'none' }}>
              {t('login.captchaError')}
            </div>
          </div>

          <div className="options">
            <label className="remember">
              <input type="checkbox" checked={rememberPwd} onChange={(e) => setRememberPwd(e.target.checked)} />
              <span>{t('login.rememberPwd')}</span>
            </label>
            <div className="forget"><a href="javascript:;">{t('login.forgetPwd')}</a></div>
          </div>

          <button type="submit" className="login-btn">{t('login.loginBtn')}</button>
        </form>
      </div>
      <div className="copyright">{t('login.copyright')}</div>
    </>
  );
}

export default LoginPage;
